import { render, staticRenderFns } from "./DiningPromotionDetail.vue?vue&type=template&id=7e41395b&scoped=true&"
import script from "./DiningPromotionDetail.vue?vue&type=script&lang=js&"
export * from "./DiningPromotionDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiningPromotionDetail.vue?vue&type=style&index=0&id=7e41395b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e41395b",
  null
  
)

export default component.exports